import { individualBannerGroup } from '@/config/configuration';

// Section heroes: sites with their own banners (individualBanner group) keep them from
// assets/img/banner/{sid}/, every other site gets the Talentspace design photo.
export type HeroPage = 'welcome' | 'jobs' | 'skilled' | 'courses';

/* eslint-disable global-require */
const talentspaceHeroes: Record<HeroPage, () => string> = {
  welcome: () => require('@/assets/talentspace/images/hero.webp'),
  jobs: () => require('@/assets/talentspace/images/Arbeit_hero.webp'),
  skilled: () => require('@/assets/talentspace/images/personal-hero.webp'),
  courses: () => require('@/assets/talentspace/images/bildung-hero.webp'),
};
/* eslint-enable global-require */

// These sites have an animated welcome banner
const GIF_WELCOME_SIDS = ['kle', 'bbg', 'en'];

export const pageHeroImage = (sid: string, page: HeroPage): string => {
  if (individualBannerGroup(sid) && page !== 'courses') {
    const ext = page === 'welcome' && GIF_WELCOME_SIDS.includes(sid) ? 'gif' : 'jpg';
    // eslint-disable-next-line global-require, import/no-dynamic-require
    return require(`@/assets/img/banner/${sid}/${page}_banner.${ext}`);
  }
  return talentspaceHeroes[page]();
};
